import React from 'react'
import { Radio } from '@gousto-internal/citrus-react'
import type { ShippingAddress } from '@library/api-user'
import { AddressRadioLabel } from './AddressRadioLabel'

function AddressRadioButton({
  address,
  isChecked,
  onChange,
}: {
  address: ShippingAddress
  isChecked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}) {
  return (
    <Radio
      id={address.id}
      name={`radio-${address.id}`}
      checked={isChecked}
      onChange={onChange}
      outline
    >
      <AddressRadioLabel address={address} focused={isChecked} />
    </Radio>
  )
}

export { AddressRadioButton }
